module.exports = __webpack_public_path__ + "static/media/USDC-BNB.ce0696d2.svg";